module.exports = __webpack_public_path__ + "302cb4d17a16584d2283291e75d59cb3.jpg";